
// Related articles for the armpit cysts article
export const armpitCystsRelatedArticles = [
  {
    id: "armpit-health-basics",
    slug: "armpit-health-basics",
    title: "Armpit Health: The Basics Everyone Should Know"
  },
  {
    id: "armpit-pain-causes",
    slug: "understanding-armpit-pain",
    title: "Understanding Armpit Pain: 10 Common Causes and Effective Remedies"
  },
  {
    id: "underarm-rash-remedies",
    slug: "effective-remedies-underarm-rash",
    title: "5 Effective Remedies for Underarm Rash: Soothing Solutions for Instant Relief!"
  }
];
